import Vue from 'vue';
import Vuex from 'vuex';

/* warehouse */
import common from './modules/warehouse/common'
import maps from './modules/maps'
import dashboard from './modules/warehouse/dashboard'
import dashboardAll from './modules/warehouse/dashboardAll'
import warehouseList from './modules/warehouse/datawarehouse/warehouse'
import userList from './modules/warehouse/user'
import supplierUser from './modules/warehouse/userSupplier'
import supplierList from './modules/warehouse/supplierwarehouse/supplier'
import productSupplier from './modules/warehouse/productSupplier'
import productList from './modules/warehouse/productwarehouse/product'
import productSerial from './modules/warehouse/productSerial'
import salesSerial from './modules/warehouse/salesSerial'
import freeTools from './modules/warehouse/freeTools'
import customerList from './modules/warehouse/customer'
import menuWH from './modules/warehouse/menuwarehouse/menu'
import po from './modules/warehouse/po'
import pdo from './modules/warehouse/pdo'
import to from './modules/warehouse/to'
import tdo from './modules/warehouse/tdo'
import sr from './modules/warehouse/sr'
import sre from './modules/warehouse/sre'
import so from './modules/warehouse/so'
import sdo from './modules/warehouse/sdo'
import stock from './modules/warehouse/stock'
import stockAdjustment from './modules/warehouse/stockAdjustment'
import stockOpname from './modules/warehouse/stockOpname'
import schedules from './modules/warehouse/schedules'
import retur from './modules/warehouse/retur'
import pdoRetur from './modules/warehouse/pdoRetur'
import nonOrder from './modules/warehouse/nonOrder'
import responseApi from './modules/warehouse/responseApi'
import emailLog from './modules/warehouse/emailLog'
import serialConvert from './modules/warehouse/serialConvert'
import webReferral from './modules/warehouse/webReferral'
import productRecall from './modules/warehouse/productRecall.js'
import purchaseOrderStockist from './modules/warehouse/purchaseOrderStockist.js';
import report from './modules/warehouse/report.js';
import voucher from './modules/warehouse/voucher.js';
import tutorialCategory from './modules/warehouse/tutorialCategory.js';
import tutorial from './modules/warehouse/tutorial.js';
import selfOrder from './modules/warehouse/selfOrder.js';

/* ecommerce */
import ecommerceCommon from './modules/ecommerce/common'
import ecommerceCourier from './modules/ecommerce/courier'
import ecommerceBank from './modules/ecommerce/bank'
import ecommerceMember from './modules/ecommerce/member'
import ecommerceTransaction from './modules/ecommerce/transaction'
import ecommerceProduct from './modules/ecommerce/product'
import ecommerceStockist from './modules/ecommerce/stockist'
import ecommerceEwallet from './modules/ecommerce/ewallet'

import mobileVersion from './modules/ecommerce/mobileVersion'

/* supplier */
import dashboardSupplier from './modules/supplier/dashboard'
import supplierProduct from './modules/supplier/product'
import poSupplier from './modules/supplier/po'
import pdoSupplier from './modules/supplier/pdo'
import userSupplier from './modules/supplier/user'
import schedulesSupplier from './modules/supplier/schedules'
import poOutstanding from './modules/supplier/poOutstanding'
import returSupplier from './modules/supplier/retur'
import pdoReturSupplier from './modules/supplier/pdoRetur'
import commonSupplier from './modules/supplier/common'

/* logistic */
import driver from './modules/logistic/driver'
import armada from './modules/logistic/armada'
import expedition from './modules/logistic/expedition'

import {
	PAGE_TITLE,
	PROGRESS_START,
	PROGRESS_FINISH,
	PROGRESS_FAIL,
} from './mutation-types';
import auth from './modules/auth';
import authSupplier from './modules/supplier/auth';

Vue.use(Vuex);

export default new Vuex.Store({
	state: {
		pageTitle: "Warehouse Milagros",
		filterParams: [],
		progressStatus: "",
		snackbar: {
			show: false,
			color: 'green accent-4',
			text: ''
		},
		attempting: false,
		error_validation: {},
		alertMultiple: [],
	},
	mutations: {
		[PAGE_TITLE](state, title) {
			state.pageTitle = title;
		},

		[PROGRESS_START](state) {
			state.progressStatus = "start";
		},

		[PROGRESS_FINISH](state) {
			state.progressStatus = "finish";
		},

		[PROGRESS_FAIL](state) {
			state.progressStatus = "fail";
		},
		setFilter(state, data) {
			state.filterParams = data
		},
		setSnackbar(state, data) {
			state.snackbar = data
		},
		hideSnackbar(state) {
			state.snackbar.show = false
		},
		setOverlay(state, data) {
			state.attempting = data
		},
		validationError(state, data) {
			state.error_validation = data
		},
		multipleAlert(state, data) {
			state.alertMultiple = data.map((el) => {
				return {
					show: true,
					message: el
				}
			})
		},
	},
	actions: {
		setPageTitle({ commit }, title) {
			commit(PAGE_TITLE, title);
		},
		isAttempting({ commit }) {
			commit('setOverlay', true);
		},
		attempted({ commit }) {
			commit('setOverlay', false);
		},
		success({ commit }, message) {
			commit('validationError', {});
			commit('multipleAlert', [])
			commit('setSnackbar', {
				show: true,
				color: 'green accent-4',
				text: message
			});
		},
		errorHandler({ commit }, response) {
			switch (response.message) {
				case 'error_validation':
				commit('validationError', response.data);
				break;

				case 'error_multiple_alert':
				commit('multipleAlert', response.data.error)
				break;

				default:
				commit('setSnackbar', {
					show: true,
					color: 'red darken-2',
					text: response.message
				});
				break;
			}
		},
	},
	modules: {
		auth,
		maps,
		common,
		dashboard,
		dashboardAll,
		warehouseList,
		userList,
		supplierUser,
		supplierList,
		productSupplier,
		productList,
		productSerial,
		salesSerial,
		freeTools,
		customerList,
		menuWH,
		po,
		pdo,
		to,
		tdo,
		sr,
		sre,
		so,
		sdo,
		stock,
		schedules,
		retur,
		pdoRetur,
		stockAdjustment,
		stockOpname,
		nonOrder,
		responseApi,
		emailLog,
		serialConvert,
		webReferral,
		productRecall,
		purchaseOrderStockist,
		report,
		voucher,
		tutorialCategory,
		tutorial,
		selfOrder,

		/*ecommerce*/
		ecommerceCommon,
		ecommerceCourier,
		ecommerceBank,
		ecommerceMember,
		ecommerceTransaction,
		ecommerceProduct,
		ecommerceStockist,
		ecommerceEwallet,

		mobileVersion,

		/* supplier */
		authSupplier,
		dashboardSupplier,
		supplierProduct,
		poSupplier,
		pdoSupplier,
		userSupplier,
		schedulesSupplier,
		poOutstanding,
		returSupplier,
		pdoReturSupplier,
		commonSupplier,

		/* logistic */
		driver,
		armada,
		expedition,
	},
});